import ItemManager from "@/components/admin/ItemManager";

export default function TestimonialsManager() {
  return (
    <ItemManager
      collection="testimonials"
      title="Testimonials"
      subtitle="Voices of winners, parents and participants shown on the website."
      testidPrefix="testimonial"
      fields={[
        { name: "name", label: "Name", type: "text" },
        { name: "role", label: "Role / Category (e.g. Little Stars Parent)", type: "text" },
        { name: "quote", label: "Quote", type: "textarea", rows: 4 },
      ]}
      cardTitle={(i) => i.name}
      cardSubtitle={(i) => i.role}
    />
  );
}
